// extracted by mini-css-extract-plugin
export default {"scrollable-container":"S751e","phase-panel":"_4lEZr","task-list":"m1DcQ"};